function homeStart() {
    var $ = jQuery.noConflict();
    var h = $('.big-image#screen-1').next().outerHeight();
    var userAgent = window.navigator.userAgent;
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
        h = h + 68;
    }
    $('body, html').animate({'scrollTop': h});
    return false;
}